import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);

export const adminLogin = (token) =>
  api.post("/admin/login", { token }).then((r) => r.data);

export const fetchContacts = (token) =>
  api.get("/admin/contacts", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const fetchAdminStats = (token) =>
  api.get("/admin/stats", { headers: { "X-Admin-Token": token } }).then((r) => r.data);

export const updateContactStatus = (token, id, status) =>
  api
    .patch(`/admin/contacts/${id}`, null, {
      params: { status },
      headers: { "X-Admin-Token": token },
    })
    .then((r) => r.data);
